import React from 'react'
import PropTypes from 'prop-types'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import { getTopPadding } from './AspectRatioImage'

const AspectRatioImagePlaceholder = ({ aspectRatio = '16:9', ...rest }) => {
  return <LoadingBox pt={getTopPadding(aspectRatio)} {...rest} />
}

AspectRatioImagePlaceholder.propTypes = {
  aspectRatio: PropTypes.string,
}

export default AspectRatioImagePlaceholder
